import * as React from 'react';
import { IChangeDeliveryDialogProps } from './ChangeDeliveryDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import { useSPContextSelector } from '../Worksale.context';
import Selectors from '../Worksale.selectors';
import { useChangeDelivery, useSetSummaryQueryData } from 'api/Worksale/worksale';
import Content from './ChangeDeliveryDialogContent';

const ChangeDeliveryDialog = (props: IChangeDeliveryDialogProps): JSX.Element => {
  const { open, onClose, dataSource, SelectAndFocusFirstRow } = props;
  const worksaleId = useSPContextSelector(Selectors.WorksaleId) || -1;

  const { mutateAsync: updateDefaultWSDeliveryMutateAsync, isLoading } = useChangeDelivery();
  const setSummaryQueryData = useSetSummaryQueryData();
  const defaultDelivery = React.useMemo(() => (dataSource?.items().find((item) => item.Primary === true)?.SiteCode), [dataSource]);
  const [selected, setSelected] = React.useState<string>('');
  const [toogleChecked, setToogleChecked] = React.useState<boolean>(true);

  const handleOnOk = async () => {
    const response = await updateDefaultWSDeliveryMutateAsync({
      WorksaleId: worksaleId,
      urlQueryParams: {
        CurrentSiteCode: defaultDelivery,
        NewSiteCode: selected,
        DefaultDelivery: toogleChecked
      }
    });

    if (response?.Status) {
      dataSource.reload().then(() => {
        SelectAndFocusFirstRow();
        setSummaryQueryData({
          Status: true,
          WorksaleSummary: response.WorksaleSummary
        });
      });
      onClose();
    }
  };

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Ok',
        isDefault: true,
        disabled: isLoading,
        listener: handleOnOk
      },
      {
        title: 'Cancel',
        listener: () => {
          onClose();
        }
      }
    ];
  };

  return (<FormViewModal
    open={open}
    loading={false}
    title='Change Delivery'
    style={{ minWidth: '450px' }}
    modalContent={<Content defaultDelivery={defaultDelivery} selected={selected} setSelected={setSelected} toogleChecked={toogleChecked} setToogleChecked={setToogleChecked} handleOnOk={handleOnOk} />}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}

  />);
};

export default ChangeDeliveryDialog;
